import { render, staticRenderFns } from "./ArtistPaymentList.vue?vue&type=template&id=050e383f&scoped=true"
import script from "./ArtistPaymentList.vue?vue&type=script&lang=js"
export * from "./ArtistPaymentList.vue?vue&type=script&lang=js"
import style0 from "./ArtistPaymentList.vue?vue&type=style&index=0&id=050e383f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e383f",
  null
  
)

export default component.exports